module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "18",
      "height": "17",
      "viewBox": "0 0 18 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 0C4.03549 0 0 3.8113 0 8.5C0 13.1887 4.03549 17 9 17C13.9645 17 18 13.1887 18 8.5C18 3.8113 13.9645 0 9 0ZM9.87097 12.7061C9.87097 13.1613 9.48195 13.5287 9 13.5287C8.51805 13.5287 8.12903 13.1613 8.12903 12.7061V7.46354C8.12903 7.00837 8.51805 6.64096 9 6.64096C9.48195 6.64096 9.87097 7.00837 9.87097 7.46354V12.7061ZM9.87097 5.03968C9.87097 5.49482 9.48195 5.86226 9 5.86226C8.51805 5.86226 8.12903 5.49482 8.12903 5.03968V4.29385C8.12903 3.83871 8.51805 3.47127 9 3.47127C9.48195 3.47127 9.87097 3.83871 9.87097 4.29385V5.03968Z",
      "fill": "#9BA1AB"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06d47bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/AlertIcon.vue
// module id = 803
// module chunks = 0